import * as React from 'react';

import {Scan} from './Scan';
import {ScanEntry} from '../data/Data';
import {StateContext} from './StateContext';
import {Status} from "./Status";

// tslint:disable-next-line function-name
export function Scans(): JSX.Element {
    const {state, dispatch} = React.useContext(StateContext);

    React.useEffect((): (() => void) => {
        function clickHandler(event: Event): void {
            if (
                state.tooltip === undefined ||
                (event.target as HTMLElement).className ===
                'c-quickscan__info' ||
                (event.target as HTMLElement).className.indexOf(
                    'c-quickscan__tooltip',
                ) > -1 ||
                (event.target as HTMLDivElement).closest('.c-quickscan__tooltip')
            ) {
                return;
            }

            dispatch({
                type: 'TOOLTIP',
                payload: {
                    questionId: undefined,
                },
            });
        }

        document.addEventListener('mousedown', clickHandler);

        return (): void => {
            document.removeEventListener('mousedown', clickHandler);
        };
    });

    return (
        <div className="c-quickscan__grid">
            <Status />
            <div className="c-quickscan__scans">
                {state.scans.map(
                    (scan: ScanEntry): JSX.Element => {
                        return (
                            <Scan
                                key={scan.id}
                                enabled={scan.selected}
                                scan={scan}
                            />
                        );
                    },
                )}
            </div>
        </div>
    );
}
